 
import { savePlayerId } from 'reduxModules/player'
import { specialVideoFetch, clearSpecialVideo } from './'

export const specialVideoDispatchers = (dispatch, props) => ({
  loadSpecialVideoInfo() {
    dispatch(specialVideoFetch(props.params.specialVideoSlug)())
  },
  clearSpecialVideo() {
    dispatch(clearSpecialVideo())
  }
})

export const specialVideoPlayerDispatchers = (dispatch, props) => ({
  loadSpecialVideo(options = {}) {
    return dispatch(
      specialVideoFetch(props?.params?.specialVideoSlug || props?.slug, options)()
    )
  },
  savePlayerId(id) {
    dispatch(savePlayerId(id))
  }
})
